<template>
  <form ref="shipmentForm">
    <div class="grid-container">
      <!-- <div class="form-group">
        <label for="partner">Shipment Partner</label>
        <select class="form-control" v-model="partner" style="color: #000">
          <option value="" disabled selected>Select</option>
          <option v-for="option in partners" :key="option.value">
            {{ option.label }}
          </option>
        </select>
      </div> -->
      <div class="form-group" v-if="getShipmentType === 'air'">
        <label for="flightNumber">Flight Number</label>
        <input
          type="text"
          class="form-control"
          v-model="flightNumber"
          required
          id="flightNumber"
          placeholder="Enter Flight Number"
        />
      </div>

      <div class="form-group" v-if="getShipmentType === 'sea'">
        <label for="vesselName">Vessel Name</label>
        <input
          type="text"
          class="form-control"
          v-model="vesselName"
          required
          id="vesselName"
          placeholder="Enter Vessel Name"
        />
      </div>

      <div class="form-group">
        <label for="departureDate">Departure Date</label>
        <input
          type="date"
          class="form-control"
          v-model="departureDate"
          required
          id="departureDate"
        />
      </div>
      <div class="form-group">
        <label for="loadingDate">Loading Date</label>
        <input
          type="date"
          class="form-control"
          v-model="loadingDate"
          required
          id="loadingDate"
        />
      </div>

      <!-- ETA -->
      <div class="form-group">
        <label for="eta">ETA</label>
        <input
          type="date"
          class="form-control"
          v-model="eta"
          required
          id="eta"
        />
      </div>

      <!-- Waybill No -->
      <div class="form-group" v-if="getShipmentType === 'air'">
        <label for="waybillNo">Air Waybill(AWB) Number</label>
        <input
          type="text"
          class="form-control"
          v-model="waybillNo"
          placeholder="Enter Waybill Number"
          required
          id="waybillNo"
        />
      </div>

      <!-- Point of Arrival -->
      <div class="form-group">
        <label for="pointOfArrival">Point of Arrival</label>
        <!-- <input
          type="text"
          class="form-control"
          v-model="pointOfArrival"
          required
          id="pointOfArrival"
          placeholder="Enter Point of Arrival"
          ref="autocompleteInput"
        /> -->

        <ports-combo-box
          refName="autocompleteInput"
          prefix="pointOfArrival"
          :destination="pointOfArrivalObj"
          @updatePort="updatePointOfArrivalObj"
          placeholder="Search Point of Arrival Port"
        />
      </div>
      <!-- Reference -->
      <div class="form-group">
        <label for="reference">Reference</label>
        <input
          type="text"
          class="form-control"
          v-model="reference"
          required
          id="reference"
          placeholder="Enter Reference Number"
        />
      </div>
      <!-- Point of Discharge -->
      <div class="form-group">
        <label for="pointOfDischarge">Point of Discharge</label>
        <!-- <input
          type="text"
          class="form-control"
          v-model="pointOfDischarge"
          required
          id="pointOfDischarge"
          placeholder="Enter Point of Discharge"
        /> -->

        <ports-combo-box
          refName="pointOfDischarge"
          prefix="pointOfDischarge"
          :destination="pointOfDischargeObj"
          @updatePort="updatePointOfDischargeObj"
          placeholder="Search Point of Discharge Port"
        />
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import PortsComboBox from "../../../components/PortsComboBox.vue";
import Dropdown from "../AddDispatch/Dropdown.vue";

export default {
  components: { Dropdown, PortsComboBox },
  name: "ShipmentDetails",
  props: {
    initialValues: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(["getShipmentType"]),
  },
  data() {
    return {
      reference: this.initialValues?.reference ?? "",
      loadingDate: this.initialValues?.loadingDate ?? "",
      eta: this.initialValues?.eta ?? "",
      departureDate: this.initialValues?.departureDate ?? "",
      vesselName: this.initialValues?.vesselName ?? "",
      pointOfArrival: this.initialValues?.pointOfArrival ?? "",
      pointOfDischarge: "",
      flightNumber: "",
      waybillNo: "",
      showError: false,
      lat: this.initialValues?.lat ?? null,
      lng: this.initialValues?.lng ?? null,
      partner: "",
      partners: [
        { value: "dhl", label: "DHL Shipping Limited" },
        { value: "evergreen", label: "Evergreen Shipping Limited" },
        { value: "cisco", label: "CISCO Shipping Limited" },
      ],
      pointOfArrivalObj: this.initialValues?.pointOfArrivalObj ?? {},
      pointOfDischargeObj: this.initialValues?.pointOfDischargeObj ?? {},
    };
  },
  methods: {
    updatePointOfArrivalObj(item) {
      this.pointOfArrival = item.name;
      this.pointOfArrivalObj = item;
    },
    updatePointOfDischargeObj(item) {
      this.pointOfDischarge = item.name;
      this.pointOfDischargeObj = item;
    },
    initializeAutocomplete() {
      const { google } = window;

      if (google?.maps) {
        this.geocoder = new google.maps.Geocoder();
        const input = document.getElementById("autocomplete");
        const autocomplete = new google.maps.places.Autocomplete(input);

        console.log(google);

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();

          if (place && place.formatted_address) {
            // The address was found in the autocomplete list
            this.pointOfArrival = place.formatted_address;

            // Get latitude and longitude from the place object
            const latLng = place.geometry?.location;

            if (latLng) {
              this.lat = latLng.lat();
              this.lng = latLng.lng();
            }
          } else {
            // The address was not in the autocomplete list, use geocoding
            const inputAddress = document.getElementById("autocomplete").value;
            console.log(
              "Address not found in autocomplete, geocoding:",
              inputAddress
            );

            // Use the Geocoder to get latitude and longitude for the entered address
            this.geocoder.geocode(
              { address: inputAddress },
              (results, status) => {
                if (
                  status === google.maps.GeocoderStatus.OK &&
                  results.length > 0
                ) {
                  const result = results[0];

                  const latLng = result.geometry.location;
                  this.lat = latLng.lat();
                  this.lng = latLng.lng();

                  console.log("Geocoded Latitude:", this.lat);
                  console.log("Geocoded Longitude:", this.lng);
                } else {
                  console.error("Geocoding failed:", status);
                }
              }
            );
          }
        });
      }
    },

    validateForm() {
      const form = this.$refs.shipmentForm;
      if (!form.checkValidity()) {
        form.reportValidity();
        return false;
      }
      return true;
    },
    getFormData() {
      return {
        reference: this.reference,
        loadingDate: this.loadingDate,
        eta: this.eta,
        departureDate: this.departureDate,
        vesselName: this.vesselName ? this.vesselName : undefined,
        pointOfArrival: this.pointOfArrival,
        pointOfDeparture: this.pointOfDischarge,
        awb: this.waybillNo ? this.waybillNo : undefined,
        flightNumber: this.flightNumber ? this.flightNumber : undefined,
        lat: this.lat,
        partner: this.partner,
        lng: this.lng,
        shipmentType: this.getShipmentType,
      };
    },
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick().then(() => this.initializeAutocomplete());
    }, 1000); // Delay of 2 seconds
  },
  watch: {
    initialValues: {
      handler(newValues) {
        if (newValues.reference) {
          this.$nextTick(() => {
            const autocompleteInput = this.$refs.autocompleteInput;
            if (autocompleteInput) {
              this.reference = newValues.reference || "";
              this.loadingDate = newValues.loadingDate || "";
              this.eta = newValues.eta || "";
              this.departureDate = newValues.departureDate || "";
              this.vesselName = newValues.vesselName || "";
              this.pointOfArrival = newValues.pointOfArrival || "";
              this.lat = newValues.lat ?? null;
              this.lng = newValues.lng ?? null;
              this.pointOfArrivalObj = newValues.pointOfArrivalObj || {};
              this.pointOfDischarge = newValues.pointOfDischarge || "";
              this.pointOfDischargeObj = newValues.pointOfDischargeObj || {};
            }
          });
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.grid-container input,
.grid-container select {
  height: 50px;
  font-size: 14px;
}

.grid-container input::placeholder,
.grid-container select {
  color: #8693a5;
}
</style>
